import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UtilityService {

  constructor() { }
  convertMonthYear(abbrMonthYear: string): string {
    if (!abbrMonthYear) {
      return abbrMonthYear;
    }
    // Define a map of abbreviated month names to full month names
    const monthMap: { [key: string]: string } = {
      "Jan": "January",
      "Feb": "February",
      "Mar": "March",
      "Apr": "April",
      "May": "May",
      "Jun": "June",
      "Jul": "July",
      "Aug": "August",
      "Sep": "September",
      "Oct": "October",
      "Nov": "November",
      "Dec": "December"
    };

    // Split the input string into month and year parts
    const [abbrMonth, year] = abbrMonthYear.split(" ");

    // Look up the full month name in the map
    const fullMonth = monthMap[abbrMonth];

    // If the abbreviation is not valid, return an error message
    if (!fullMonth) {
      return abbrMonthYear;
    }

    // Return the full month and year as a string
    return `${fullMonth} ${year}`;
  }
}
